module.exports = __webpack_public_path__ + "static/media/riviero_korhn_kolisnsky.24469290.jpg";